<template>
  <div v-loading="loading"
      :element-loading-text="loadingText"
      element-loading-spinner="el-icon-loading">
    <div style="margin-top: 20px;">
      <!-- <el-button @click="goBack" size="medium" class="btn1">返回个人中心</el-button> -->
    <div   @click="goBack" style="cursor:pointer;color:#008A2C">
        <el-button type="info"  style="background-color:#008A2C;" icon="el-icon-back" circle></el-button> &nbsp;返回个人中心
     </div>
    </div>
    <el-row :gutter="0">
      <el-col :span="16">
        <el-row :gutter="0" class="eltable row">
          <el-col :span="24">
            <div class="gridContent bggray2 fb tc">
              问题反映单-{{ commit.feedbackNumber }}
            </div>
          </el-col>
          <!-- <el-col :span="4">
            <div class="gridContent bggray2 tc">标题</div>
          </el-col>
          <el-col :span="20">
            <div class="gridContent">{{ commit.feedTitle }}</div>
          </el-col> -->
          <el-col :span="4">
            <div class="gridContent bggray2" style="
                display: flex;
                align-items: center;
                justify-content: center;
                height: 50px;
              ">
              情况描述
            </div>
          </el-col>
          <el-col :span="20">
            <div class="gridContent" style="height: 50px">
              {{ commit.feedContent }}
            </div>
          </el-col>
          <el-col :span="4">
            <div class="gridContent bggray2 tc">反映人</div>
          </el-col>
          <el-col :span="8">
            <div class="gridContent">{{ commit.feedUser }}</div>
          </el-col>
          <el-col :span="4">
            <div class="gridContent bggray2 tc">反映类型</div>
          </el-col>
          <el-col :span="8">
            <div class="gridContent">{{ commit.feedType }}</div>
          </el-col>
          <el-col :span="4">
            <div class="gridContent bggray2 tc">反映日期</div>
          </el-col>
          <el-col :span="8">
            <div class="gridContent">{{ dateFormat(commit.feedDate) }}</div>
          </el-col>
          <el-col :span="4">
            <div class="gridContent bggray2 tc">联系方式</div>
          </el-col>
          <el-col :span="8">
            <div class="gridContent">{{ commit.telephone }}</div>
          </el-col>
          <!-- <el-col :span="4">
            <div class="gridContent bggray2 tc">是否匿名</div>
          </el-col>
          <el-col :span="8">
            <div class="gridContent">
              {{ commit.isAnonymous == 1 ? "否" : "是" }}
            </div>
          </el-col> -->
          <el-col :span="4">
            <div class="gridContent bggray2 tc">受理部门</div>
          </el-col>
          <el-col :span="8">
            <div class="gridContent">{{ commit.receiveDept }}</div>
          </el-col>
          <el-col :span="4">
            <div class="gridContent bggray2 tc">办理人</div>
          </el-col>
          <el-col :span="8">
            <div class="gridContent">
              {{ commit.handleUser != null ? commit.handleUser : "" }}
            </div>
          </el-col>
         
          <el-col :span="4">
            <div class="gridContent bggray2 tc" style="
                display: flex;
                align-items: center;
                justify-content: center;
                height: 50px;
              ">
              建议
            </div>
          </el-col>
          <el-col :span="20">
            <div class="gridContent" style="height: 50px">
              {{ commit.advice }}
            </div>
          </el-col>
          <el-col :span="4">
            <div class="gridContent bggray2 tc" style="
                display: flex;
                align-items: center;
                justify-content: center;
                height: 200px;
              ">
              图片/视频
            </div>
          </el-col>
          <el-col :span="20">
            <div class="gridContent" style="height: 200px">
              <div v-for="item in commit.pics" :key="item.name" class="avatar"
                style="position: relative; margin-left: 1px; object-fit: fill">
                <el-image v-if="
                  item.type == 'jpg' ||
                  item.type == 'png' ||
                  item.type == 'gif' ||
                  item.type == 'bmp' ||
                  item.type == 'jpeg'
                " :key="item.name" height="88px" :preview-src-list="srcList" :src="item.url" width="88px" />
                <video v-if="item.type == 'MOV' || item.type == 'mp4'" :preload="preload" :height="height"
                  :width="width" align="center" :controls="controls" :autoplay="autoplay" style="" type="video/mp4"
                  :src="item.url"></video>
                <!-- <i class="close el-icon-error" @click="removeUpfile(item)"></i> -->
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="8" style="float: right; padding-left: 10px">
        <el-row :gutter="0" class="eltable rightTable" :style="{ height: contentHeight }">
          <el-col :span="24">
            <div class="gridContent bggray2 fb tc">办理过程</div>
          </el-col>
          <el-col :span="24">
            <!-- <el-steps
              direction="vertical"
              :active="active"
              align-center
              style=""
              progressDot
            >
              <el-step
              v-for="item in commit.handleProcess"
              :key="item.id"
                :title="item.handleUser + ' ' + item.nodeName"
                :description="item.handleTime"
                style="margin-bottom:10px"
              ></el-step>
            </el-steps> -->
            <div :style="{ height: heightDiv }" class="rightDiv">
              <el-timeline>
                <el-timeline-item v-for="(item, index) in commit.handleProcess" :key="item.id"
                  :color="index == 0 ? 'rgb(8,128,187)' : 'rgb(0,138,44)'">
                  {{
                  item.handleUser}}&nbsp;&nbsp;&nbsp;&nbsp;{{item.nodeName}}&nbsp;&nbsp;&nbsp;&nbsp;{{item.handleTime}}
                  <el-card v-if="item.nodeName == '问题评价'" style="margin-top:10px;padding-bottom:20px;margin-right: 20px;">
                    <div><span style="font-weight: bold;">评价内容：</span>{{ item.handleText }}</div>
                    <el-rate :value="(parseInt(item.f1) * 5) / 100" disabled score-template="{value}">
                    </el-rate>
                  </el-card>
                  <el-card v-else-if="item.nodeName == '转办问题'" style="margin-top:10px;padding-bottom:20px;margin-right: 20px;">
                    <div><span style="font-weight: bold;">转办内容：</span>{{item.handleText}}</div>
                  </el-card>
                  <el-card v-else-if="item.nodeName != '提交问题'&&item.nodeName!='更新问题'"
                    style="margin-top:10px;padding-bottom:10px;margin-right: 20px;">
                    <div><span style="font-weight: bold;">回复内容：</span>{{item.handleText}}</div>
                    <div><span style="font-weight: bold;">图片或视频：</span></div>
                    <div v-for="item in JSON.parse(item.pics)" :key="item.name" class="avatar"
                      style="position: relative; margin-left: 1px;">
                      <el-image v-if="
                        item.type == 'jpg' ||
                        item.type == 'png' ||
                        item.type == 'gif' ||
                        item.type == 'bmp' ||
                        item.type == 'jpeg'
                      " :key="item.name" height="88px" :preview-src-list="enlarges" :src="item.url" width="88px"
                        @click="enlarge(item.url)" />
                      <video v-if="item.type == 'MOV' || item.type == 'mp4'" :preload="preload" :height="height"
                        :width="width" align="center" :controls="controls" :autoplay="autoplay" style=""
                        type="video/mp4" :src="item.url"></video>
                      <!-- <i class="close el-icon-error" @click="removeUpfile(item)"></i> -->
                    </div>
                  </el-card>
                </el-timeline-item>
                <el-timeline-item :color="
                  commit.state == 0 ? 'rgb(228,231,237)' : 'rgb(249,74,86)'
                " :timestamp="commit.accomplishTime">
                  问题办结
                </el-timeline-item>
              </el-timeline>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
   
  </div>
</template>
  
<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import "../static/css/my.css";
import axios from "axios";
import { uploadPath, fileAcquisition,xzztcUrl } from "@/config/net.config.js";
import moment from "moment";

export default {
  name: "serviceInfor",
  data() {
    return {
      commit: {},
      id: "",//
      url: "",
      xzztcToken: "",
      uploadPath: uploadPath,
      fileAcquisition: fileAcquisition,
      playStatus: "",
      muteStatus: "",
      isMute: true,
      isPlay: false,
      width: "88", // 设置视频播放器的显示宽度（以像素为单位）
      height: "88", // 设置视频播放器的显示高度（以像素为单位）
      preload: "auto", //  建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
      controls: true, // 确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
      autoplay: "",
      srcList: [],
      enlarges: [],
      contentHeight: 0,
      heightDiv: 0,
      loadingText: "数据正在加载中，请稍后...",
      loading: true,
    };
  },
  computed: {},
  mounted() {
    this.xzztcToken = sessionStorage.getItem("xzztcToken")
    this.id = this.$route.query.id
    this.getFeedback();
    this.getHeight();
    setTimeout(()=>{
      this.loading=false
    },200)
  },
  methods: {
    enlarge(url) {
      this.enlarges = []
      this.enlarges.push(url)
      console.log(this.enlarges);
    },
    getHeight() {
      this.$nextTick(function () {
        this.contentHeight =
          document.getElementsByClassName("row")[0].clientHeight;
        this.heightDiv = this.contentHeight - 60 + "px";
        this.contentHeight = this.contentHeight + "px";
        console.log(this.contentHeight, this.heightDiv); //元素高度
      });
    },
    dateFormat(date) {
      if (date != null && date != "") {
        return moment(date).format("YYYY-MM-DD");
      } else {
        return "";
      }
    },
    getFeedback() {
      axios.defaults.headers["authorization"] = this.xzztcToken;
      //get，可以设置全局地址提高代码复用率，减少自己写代码，就不用每个都写这么长的地址，嘿嘿
      axios.defaults.baseURL =xzztcUrl;
      axios
        .get("/api/xzztc/feedback/obtainFeedbackDetail", {
          params: {
            feedId: this.id,
          },
        })
        .then((res) => {
          // console.log(res.data.data);
          if (
            res.data.msgCode == 0 &&
            res.data.data != {} &&
            res.data.data != null
          ) {
            this.commit = res.data.data;
            if (this.commit.pics != null && this.commit.pics != undefined)
              this.commit.pics = JSON.parse(this.commit.pics);
            if (this.commit.pics != []) {
              this.commit.pics.forEach((item) => {
                if (item.type != "MOV" && item.type != "mp4") {
                  this.srcList.push(item.url);
                }
              });
            }
            this.commit.handleProcess.forEach((item) => {
              item.handleTime = moment(item.handleTime).format(
                "YYYY-MM-DD HH:mm:ss"
              );
            });
            if (this.commit.accomplishTime != null) {
              this.commit.accomplishTime = moment(
                this.commit.accomplishTime
              ).format("YYYY-MM-DD HH:mm:ss");
            }

            this.active = this.commit.handleProcess.length;
            console.log(this.active);
          }
        });
    },
    goBack() {
      this.$router.push("/userCenter");
    }
  },
  components: {
    // HelloWorld
  },
};
</script>
<style>
.el-tabs__item.is-active {
  color: #2c3e50 !important;
  font-weight: bold;
}

.eltable {
  border-left: 1px solid #ddd;
  margin-top: 20px;
  border-top: 1px solid #ddd;
}

.eltable .gridContent {
  padding: 10px 8px;
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  min-height: 19px;
}

.rightTable {
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
}

.rightDiv {
  padding-top: 10px;
  margin-left: 10%;
  padding-left: 5px;
  overflow-y: scroll;
}

.el-rate__icon {
  font-size: 28px;
}

.bggray2 {
  background-color: #e2f3cf;
}

.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 88px;
  height: 88px;
  line-height: 88px;
  text-align: center;
  margin-right: 10px;
}

.avatar {
  width: 88px;
  height: 88px;
  float: left;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin-right: 10px;
  line-height: 88px;
  text-align: center;
  /* display: block;  */
}

>>>.el-image__error,
>>>.el-image__inner,
>>>.el-image__placeholder {
  width: 100%;
  height: 88px;
}

>>>.el-step__title.is-finish {
  color: rgb(17, 1, 69);
  font-size: 14px;
  /* text-align: center; */
}

>>>.el-step__head.is-finish {
  color: #008a2c;
  border-color: #008a2c;
  font-size: 14px;
  text-align: center;
  /* justify-content: center; */
}

>>>.el-step__description.is-finish {
  color: rgb(17, 1, 69);
  font-size: 14px;
  /* text-align: center; */
}

::-webkit-scrollbar {
  width: 5px;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.1);
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: rgba(0, 0, 0, 0.1);
}

.btn1.el-button {
  background-color: #008A2C;
  color: white;
}

.btn1.el-button:hover {
  color: white;
  border-color: #e0fae8;
  background-color: #008a2cc9;
}
</style>